import { Trans } from "@lingui/react/macro";

import { rankSteps, useRankLookup } from "@/features/matches";
import { cn } from "@/shared/lib";

type RankCardProps = {
  badge: number;
  // Ранг после последнего рейтингового матча неделю назад; таких матчей нет — `null`.
  weekAgo: number | null;
};

// Ранг в шапке профиля: значок подуровня, название и изменение за неделю.
export const RankCard = ({ badge, weekAgo }: RankCardProps) => {
  const rank = useRankLookup()(badge);
  const steps = weekAgo === null ? null : rankSteps(weekAgo, badge);
  const change = Math.abs(steps ?? 0);
  return (
    <div className="flex items-center gap-3.5 rounded-xl border border-border bg-surface-raised py-2.5 pr-5 pl-2.5">
      {rank.iconUrl !== null && (
        <img src={rank.iconUrl} alt="" className="h-[70px] w-[86px] shrink-0 object-contain" />
      )}
      <span className="flex flex-col leading-tight">
        <span className="text-xs font-semibold tracking-[0.08em] text-subtle uppercase">
          <Trans>Rank</Trans>
        </span>
        <span className="font-display text-3xl font-bold">{rank.name}</span>
        {steps !== null && (
          <span
            className={cn(
              "text-[13px] font-semibold",
              steps > 0 ? "text-good" : steps < 0 ? "text-bad" : "text-subtle",
            )}
          >
            {steps > 0 ? (
              <Trans>▲ +{change} this week</Trans>
            ) : steps < 0 ? (
              <Trans>▼ −{change} this week</Trans>
            ) : (
              <Trans>No change this week</Trans>
            )}
          </span>
        )}
      </span>
    </div>
  );
};
